// extracted by mini-css-extract-plugin
export default {"header":"NotFound-header-P6p","goBack":"NotFound-goBack-fM7","widgets":"NotFound-widgets-_Dr","widget":"NotFound-widget-Jch","title":"NotFound-title-fOo"};